module.exports = __webpack_public_path__ + "img/mercado.20c394d4.jpg";